import { elakay_API } from "../../config";
import { getUserPUBToken} from "./";
import {isAuthenticated  } from "../auth";
// import queryString from "query-string";
// const queryString = require('query-string');
import {decryptData}  from '../auth/elakayCryptage'
import { elakayAutoText } from "../pageInside/dataElakay";
import { checkoutAttempt } from "./checkoutAttempt";
import { locationQueryParams } from "../../utils/buyerLocation";
import { prepareUpload } from "../../utils/uploadPolicy";
import { readUploadResponse } from "../../utils/uploadResponse";
import { uploadFileRequest } from "../../utils/uploadRequest";


let __elakayInfoSource;
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["apiProduct"]?.[key] || fallback;

const normalizeToken = (value) => {
  if (typeof value !== "string") return "";
  const token = value.trim();
  if (!token || token === "undefined" || token === "null" || token === "false") return "";
  return token.split(".").length === 3 ? token : "";
};
const getAuthToken = () => normalizeToken(isAuthenticated()?.token);
const getPubToken = () => normalizeToken(getUserPUBToken()?.pubToken);
const bearerHeaders = (headers = {}) =>
  Object.fromEntries(
    Object.entries(headers)
      .map(([key, value]) => [key, normalizeToken(value)])
      .filter(([, value]) => value)
      .map(([key, value]) => [key, `Bearer ${value}`])
  );
const clampLimit = (value, fallback = 48, max = 100) => Math.min(Math.max(parseInt(value, 10) || fallback, 1), max);
const cleanSkip = (value) => Math.max(parseInt(value, 10) || 0, 0);
const isMongoObjectId = (value) => typeof value === "string" && /^[a-f\d]{24}$/i.test(value);
const invalidProductIdResult = { success: false, get error() { return elakayAutoText("h_47db7bf794a4e9", "A loaded product ObjectId is required"); } };
const readJsonResponse = async (response, actionLabel) => {
    const raw = await response.text();
    let payload;
    try {
        payload = raw ? JSON.parse(raw) : {};
    } catch (_) {
        return {
            success: false,
            error: `${actionLabel}: the API returned HTML instead of JSON (HTTP ${response.status}). Restart the API server and verify ${response.url}.`,
        };
    }
    if (!response.ok) {
        return { success: false, code: payload.code, error: payload.error || payload.message || `${actionLabel} failed (HTTP ${response.status}).` };
    }
    return payload;
};
const buildQuery = (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.set(key, value);
    }
  });
  return query.toString();
};

// export const createProduct = async (token, product) => {
//     try {
//     return fetch(`${elakay_API}/products/create`, {
//         method: "POST",
//         headers: {
//             Accept: "application/json",
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`
//         },
//         body: JSON.stringify(product)
//     })
//         .then(response => {
//                 // Vérifie si le statut est une erreur HTTP
//     if (!response.ok) {
//       const errorData = await response.json();
//       throw new Error(errorData.error || "Erreur d'identification");
//     }
//     const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
//         const donneesClaires = await decryptData(encryptedData);
    
//         return donneesClaires;
//         })
//   } catch (err) {
//     console.error("Erreur lors du creation item :", err);
//    return {
//       success: false,
//       error: err.message || "Une erreur inconnue est survenue"
//     };
//   }
// };

// createProduct.js
export const createProduct = async (
  token,
  product,
  { decrypt = true, timeout = 15000 } = {}
) => {
  const controller = new AbortController();
  const t = setTimeout(() => controller.abort(), timeout);

  try {
    const res = await fetch(`${elakay_API}/products/create`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(product),
      signal: controller.signal,
    });

    // Récupère le corps une seule fois (texte), puis parse selon le besoin
    const raw = await res.text(); // peut être "" (204/erreur custom)
    const tryParseJSON = (s) => {
      try { return s ? JSON.parse(s) : null; } catch { return null; }
    };

    if (!res.ok) {
      const errJson = tryParseJSON(raw);
      const msg =
        errJson?.error ||
        errJson?.message ||
        `Erreur HTTP ${res.status} lors de la création du produit`;
      throw new Error(msg);
    }

    // Réponse OK
    // const json = tryParseJSON(raw);
    // Si le backend renvoie un payload chiffré (iv, salt, data), on le déchiffre.
    // const data = decrypt && json ? await decryptData(json) : json;  
  // const data = decrypt && json ? await decryptData(json) : json;
    
    const encryptedData = await tryParseJSON(raw); // doit être au format chiffré (avec iv, salt, etc.)
    const data = decrypt && await decryptData(encryptedData);
          data.success = true
    return data
  } catch (err) {
    console.error("Erreur lors de la création du produit:", err);
    return {
      success: false,
      error: err?.message || "Une erreur inconnue est survenue",
    };
  } finally {
    clearTimeout(t);
  }
};


export const getProducts = (skip, limit, sortBy, deal, filters) => {
    const query = buildQuery({
        sortBy: sortBy || "createdAt",
        skip: cleanSkip(skip),
        order: "desc",
        limit: clampLimit(limit),
        deal
    });
    return fetch(`${elakay_API}/products?${query}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        }
    })
        .then(response => {
            return response.json();
        })
        .catch(err =>  {return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    }
}
);
};

// `location` (optional): { country, state, city, postalCode, latitude,
// longitude } -- the buyer's searched location (utils/buyerLocation.js), sent
// as query params (never body -- productSearch's/ProductLoading's generic
// filter loops iterate every body key). Server-side filtering happens
// regardless (elakay_services/localSelling.js); this is just what to search.
export const getProductsF = async (skip, limit, sortBy, filters, location) => {
    try {
 const query = buildQuery({
    sortBy: sortBy || "createdAt",
    skip: cleanSkip(skip),
    order: "desc",
    limit: clampLimit(limit),
    ...locationQueryParams(location)
 });
 const response = await fetch(`${elakay_API}/productsF?${query}`, {
	        method: "POST",
	        headers: {
	            Accept: "application/json",
	            "Content-Type": "application/json",
	            ...bearerHeaders({
	                Authorization: getAuthToken(),
	                UserPUBToken: getPubToken()
	            })
	        },
	        body: JSON.stringify(filters)
    })
        // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
        const donneesClaires = await decryptData(encryptedData);
    
        return donneesClaires;
} catch (err) {
    // ✅ Was mislabeled "Erreur lors du chargement des catégories" (copy-
    // pasted from the categories loader) -- this is /productsF, and every
    // caller (DataLoader.jsx's callProductsLoader) already treats a
    // `{success:false, error}` return here as "no product data for this
    // facet" and safely returns {} for it, without ever throwing back into
    // Promise.all. The wrong label just made a products-only failure read
    // in the console as if category loading had failed too.
    console.error("Erreur lors du chargement des produits (/productsF) :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

// `location`: see getProductsF's comment -- query params only, `filters`
// (the request body here) is iterated key-by-key server-side expecting
// array-shaped filter values, so location must never be merged into it.
export const getProductSearch = async (skip, limit, sortBy, ci, search='', filters, location) => {
      try {
 const query = buildQuery({
    sortBy: sortBy || "createdAt",
    skip: cleanSkip(skip),
    order: "desc",
    limit: clampLimit(limit, 50),
    ci,
    search,
    ...locationQueryParams(location)
 });
 const response = await  fetch(`${elakay_API}/productSearch?${query}`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            ...bearerHeaders({ Authorization: getAuthToken() })
        },
        body: JSON.stringify(filters)
    })
        // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
        const donneesClaires = await decryptData(encryptedData);
    
        return donneesClaires;
} catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const searchProductsByImage = async (file, limit, minSimilarity) => {
    try {
        const query = buildQuery({
            limit: clampLimit(limit, 24),
            minSimilarity: minSimilarity ?? 25,
            ...locationQueryParams(undefined)
        });
        const formData = new FormData();
        formData.append("image", await prepareUpload("imageSearch", file));

        const response = await fetch(`${elakay_API}/products/searchByImage?${query}`, {
            method: "POST",
            headers: bearerHeaders({ Authorization: getAuthToken() }),
            body: formData
        });

        // A proxy 413 page is HTML: readUploadResponse turns it into a message.
        if (!response.ok) await readUploadResponse(response);
        const encryptedData = await response.json();
        const donneesClaires = await decryptData(encryptedData);

        return donneesClaires;
    } catch (err) {
        console.error("Erreur lors de la recherche par image :", err);
        return {
            success: false,
            error: err.message || "Une erreur inconnue est survenue"
        };
    }
};

export const getProductSearchByImageHash = async (skip, limit, imageQuery, minSimilarity) => {
    try {
        const query = buildQuery({
            q: imageQuery,
            skip: cleanSkip(skip),
            limit: clampLimit(limit, 24),
            minSimilarity: minSimilarity ?? 25,
            ...locationQueryParams(undefined)
        });
        const response = await fetch(`${elakay_API}/products/searchByImageHash?${query}`, {
            method: "GET",
            headers: bearerHeaders({ Authorization: getAuthToken() })
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || "Erreur d'identification");
        }
        const encryptedData = await response.json();
        const donneesClaires = await decryptData(encryptedData);

        return donneesClaires;
    } catch (err) {
        console.error("Erreur lors de la recherche par image :", err);
        return {
            success: false,
            error: err.message || "Une erreur inconnue est survenue"
        };
    }
};

// These mutations resolve with an error object (rather than rejecting), so
// callers must be able to distinguish every failed HTTP response from a save.
const readFilterProductResponse = async (response, action) => {
    const fallback = `${action} failed (HTTP ${response.status}).`;
    let payload;
    try {
        payload = await response.json();
    } catch (_) {
        return { success: false, error: fallback };
    }
    if (!payload || typeof payload !== "object" || Array.isArray(payload) || Object.keys(payload).length === 0) {
        return { success: false, error: fallback };
    }
    if (!response.ok || payload.success === false || payload.error) {
        const error = [payload.error, payload.message].find((value) => typeof value === "string" && value.trim());
        return { ...payload, success: false, error: error || fallback };
    }
    return payload;
};

export const createFilterProduct =async (token, ProductID, Filters) => {
     try{
   const response = await fetch(`${elakay_API}/products/createFilter/${ProductID}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(Filters)
    })
    const encryptedData = await readFilterProductResponse(response, "Creating the filter combination");
    if (encryptedData.success === false) return encryptedData;
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};
export const updateFilterProduct = (token, ProductID, filterID, Filters, requiresDropshippingConfirmation = false) => {
    return fetch(`${elakay_API}/products/updateFilter/${ProductID}/${filterID}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            ...(requiresDropshippingConfirmation ? { "X-Dropshipping-Password-Required": "true" } : {})
        },
        body: JSON.stringify(Filters)
    })
        .then(response => readFilterProductResponse(response, "Updating the filter combination"))
        .catch(err => {
             return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

export const parcelProductUA = (token, ProductID, filterID, parcel) => {
    return fetch(`${elakay_API}/products/parcelProductUA/${ProductID}/${filterID}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(parcel)
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};


// `password`, when provided, is sent directly (bypassing the global
// window.fetch password-confirmation interceptor via X-Elakay-Password-Attached
// -- see isSensitiveDropshippingRequest) instead of relying on that
// interceptor to collect it. Callers that already have the password in hand
// (e.g. their own inline confirmation prompt) should use it.
export const deleteFilterProduct = (token, ProductID, filterID, requiresDropshippingPassword = false, confirmation = {}) => {
    return fetch(`${elakay_API}/products/deleteFilter/${ProductID}/${filterID}`, {
        method: "DELETE",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            ...(confirmation.confirmationToken
                ? { "X-Elakay-CJ-Confirmation": confirmation.confirmationToken, "X-Dropshipping-Action": confirmation.confirmationAction || "CJ_FILTER_DELETE" }
                : requiresDropshippingPassword ? { "X-Dropshipping-Password-Required": "true" } : {})
        }
    })
        .then(response => readFilterProductResponse(response, "Deleting the filter combination"))
        .catch(err => {
             return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

const readProductMutationResponse = async (response) => {
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
        return { ...data, success: false, error: data?.error || data?.message || `HTTP ${response.status}` };
    }
    return data;
};

export const linkCTP = (token, ID, categories) => {
    return fetch(`${elakay_API}/products/linkCTP/${ID}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(categories)
    })
        .then(readProductMutationResponse)
        .catch(err => {
             return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

export const UnlinkCTP = (token, ID, catID) => {
    return fetch(`${elakay_API}/products/UnlinkCTP/${ID}/${catID}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })
        .then(readProductMutationResponse)
        .catch(err => {
             return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

// Resolves {} on success, { error } otherwise (never throws). The photo is
// checked and, when heavy, compressed before sending (uploadPolicy).
export const createImageProduct = (token, filterID, ProductID, photo) => uploadFileRequest({
    url: `${elakay_API}/products/updateGaleries/${ProductID}`,
    feature: "productImage",
    field: "photo",
    file: photo,
    headers: { Accept: "application/json", Authorization: `Bearer ${token}` },
})


export const AddImgGraphicOrder = (token, order_id, photo, ust='c') => uploadFileRequest({
    url: `${elakay_API}/order/AddImgGraphicOrder/${order_id}?ust=${ust}`,
    feature: "orderImage",
    field: "photo",
    file: photo,
    headers: { Accept: "application/json", Authorization: `Bearer ${token}` },
})

export const getUserProducts = async (token, skip, limit, sort, dealToday, params, filters) => {

     try{
   const query = buildQuery({
        category: params?.category,
        sortBy: sort?.sortBy || "createdAt",
        asc: sort?.asc,
        skip: cleanSkip(skip),
        up: sort?.unpublished ? sort.unpublished : false,
        dropshipping: sort?.dropshipping ? sort.dropshipping : false,
        trash: sort?.trash ? sort.trash : false,
        order: "desc",
        limit: clampLimit(limit),
        dealToday,
        search: params?.search
   });
   const response = await fetch(`${elakay_API}/products/user?${query}`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            // UserPUBToken : `Bearer ${pubToken}`
        },
        body: JSON.stringify(filters)
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

    const encryptedData = await response.json();
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
   console.error("Erreur lors du chargement des catégories :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

// `location`: see getProductsF's comment above -- query params only.
// `shopId` (multi-shop, optional): one of the owner's shops; omitted = the
// owner's original shop (the legacy shop page).
// options.asc: ascending order (the server reads ?asc=1; sortBy is
// whitelisted server-side, see lakayShopListing.js).
export const getLakayUser = async (id, skip, limit, sortBy, ci, search='', filters, location, shopId, options = {}) => {
     try{
   const query = buildQuery({
        shop: shopId || undefined,
        sortBy: sortBy || "createdAt",
        skip: cleanSkip(skip),
        order: options?.asc ? "asc" : "desc",
        asc: options?.asc ? 1 : undefined,
        limit: clampLimit(limit, 50),
        ci,
        search,
        ...locationQueryParams(location)
   });
   const response = await fetch(`${elakay_API}/products/lakayUser/${encodeURIComponent(id)}?${query}`, {
	        method: "POST",
	        headers: {
	            Accept: "application/json",
	            "Content-Type": "application/json",
	            ...bearerHeaders({ Authorization: getAuthToken() })
	        },
	        body: JSON.stringify(filters)
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
     const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const commentProduct = async (productId, skip, limit,) => {
     try{
   const query = buildQuery({
        skip: cleanSkip(skip),
        limit: clampLimit(limit, 20)
   });
   const response = await fetch(`${elakay_API}/commentProduct/${encodeURIComponent(productId)}?${query}`, {
        method: "GET"
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
     const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

// The destination (saved Target Location, else the server's address / IP
// fallback) decides availability: a product of a seller whose Strict Location
// zone excludes it answers 404 PRODUCT_UNAVAILABLE_IN_LOCATION -- returned as
// `{ success:false, code, location }` so the page can say why.
export const getProductPreview = async (productId, signal, shopId) => {
     try{
   const query = buildQuery({ ...locationQueryParams(undefined), ...(shopId ? { shop: shopId } : {}) });
   const response = await fetch(`${elakay_API}/products/preView/${productId}${query ? `?${query}` : ""}`, {
        method: "GET",
        headers: bearerHeaders({ Authorization: getAuthToken() }),
        ...(signal ? { signal } : {})
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      if (errorData?.code === "PRODUCT_UNAVAILABLE_IN_LOCATION") {
        return { success: false, error: errorData.error, code: errorData.code, location: errorData.location || null };
      }
      throw new Error(errorData.error || "Erreur d'identification");
    }
     const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    if (err.name !== "AbortError") {
      console.error("Erreur lors du chargement des catégories :", err);
    }
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};



export const getUserProductPreview = async (productId) => {
     try{
   const response = await fetch(`${elakay_API}/products/preView/user/${productId}`, {
        method: "GET",
        headers: bearerHeaders({ Authorization: getAuthToken() })
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
     const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const readProductByCategoryID = (skip, limit, CategoryId) => {
    return fetch(`${elakay_API}/products/category/${CategoryId}?skip=${skip}&order=desc&limit=${limit}`, {
        method: "GET"
    })
        .then(response => {
            return response.json();
        })
        .catch(err => { return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    }
}
);
};

// Corbeille (soft-delete) -- voir server_elakay/elakay_controllers/product/productDeletion.js.
// listTrashProducts réutilise /products/user (readProductUser) avec trash=1,
// pas une route dédiée -- même pagination/tri/projection que getUserProducts.
export const softDeleteProduct = async (token, productID) => {
    try {
        const response = await fetch(`${elakay_API}/products/${productID}/softDelete`, {
            method: "PUT",
            headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        });
        const encryptedData = await readJsonResponse(response, "Move product to trash");
        if (encryptedData.error) return encryptedData;
        return await decryptData(encryptedData);
    } catch (err) {
        return { success: false, error: err.message || "Une erreur inconnue est survenue" };
    }
};

export const restoreProduct = async (token, productID) => {
    try {
        const response = await fetch(`${elakay_API}/products/${productID}/restore`, {
            method: "PUT",
            headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        });
        const encryptedData = await readJsonResponse(response, "Restore product");
        if (encryptedData.error) return encryptedData;
        return await decryptData(encryptedData);
    } catch (err) {
        return { success: false, error: err.message || "Une erreur inconnue est survenue" };
    }
};

export const permanentDeleteProduct = async (token, productID) => {
    try {
        const response = await fetch(`${elakay_API}/products/${productID}/permanentDelete`, {
            method: "DELETE",
            headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        });
        const encryptedData = await readJsonResponse(response, "Permanently delete product");
        if (encryptedData.error) return encryptedData;
        return await decryptData(encryptedData);
    } catch (err) {
        return { success: false, error: err.message || "Une erreur inconnue est survenue" };
    }
};

export const getTrashProducts = (token, skip, limit) => getUserProducts(token, skip, limit, { sortBy: "deletedAt", asc: false, trash: true }, false, {}, {});

export const AddToDealToDay = (token, productID, deal) => {
    return fetch(`${elakay_API}/products/AddToDeal/${productID}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(deal)
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
}; 

// add image note product

export const AddProductImageNote = (token, productID, photo) => uploadFileRequest({
    url: `${elakay_API}/products/updateNoteImageProduct/${productID}`,
    method: "PUT",
    feature: "productNoteImage",
    field: "photo",
    file: photo,
    headers: { Accept: "application/json", Authorization: `Bearer ${token}` },
});
export const AddProductDescription = (token, productID, note) => {

    return fetch(`${elakay_API}/products/updateNoteDescriptionProduct/${productID}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },

        body: JSON.stringify(note)
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
}

export const deleProductImageNote = (token, ProductID, galerieID) => {

    return fetch(`${elakay_API}/products/deleteNoteProduct/${ProductID}/${galerieID}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            //'content-type': 'multipart/form-data',
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

export const deleteVote = (productID, token, vote) => {
    if (!isMongoObjectId(productID)) return Promise.resolve(invalidProductIdResult);
    return fetch(`${elakay_API}/products/deleteVote/${productID}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ vote })

    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
}; 

export const vote = async (productID, token, vote) => {
   if (!isMongoObjectId(productID)) return invalidProductIdResult;
   try{
   const response = await  fetch(`${elakay_API}/products/vote/${productID}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ vote })

    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
    // The endpoint may return the existing encrypted payload or plain Product
    // JSON on legacy/plain deployments. decryptData safely handles both.
    const responseData = await response.json();
    const donneesClaires = await decryptData(responseData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors de l'enregistrement du vote :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
}; 

export const deleteImageProduct = (token, ProductID, galerieID) => {

    return fetch(`${elakay_API}/products/deleteGalerie/${ProductID}/${galerieID}`, {
        method: "DELETE",
        headers: {
            Accept: "application/json",
            //'content-type': 'multipart/form-data',
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

export const updateProduct = (token, id, product) => {
    return fetch(`${elakay_API}/products/update/${id}`, {
        method: "PATCH",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(product)
    })
        .then(readProductMutationResponse)
        .catch(err => {
             return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

export const syncProductImageUrls = async (token, productId) => {
  try {
    const response = await fetch(`${elakay_API}/products/sync-image-urls/${productId}`, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`
      }
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data?.error || data?.message || `HTTP ${response.status}`);
    return data;
  } catch (err) {
    return { success: false, error: err.message || "Unable to update product images" };
  }
};

// --- CJ Dropshipping Sync (onglet "CJ Dropshipping Sync" dans editProduct) ---

export const getCJCompare = (token, productId, refresh = false) => {
    return fetch(`${elakay_API}/dropshipping/cj/products/${productId}/compare${refresh ? "?refresh=true" : ""}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        },
    })
        .then(response => response.json())
        .catch(err => ({ success: false, error: err.message || "Une erreur inconnue est survenue" }));
};

// `includeAllVariants` clears dropshippingData.excludedVariantExternalIds
// server-side before refreshing (see cjProductSyncService.syncCJProduct) --
// the only way to bring back a variant excluded once at import time.
export const syncCJProductManual = (token, productId, { includeAllVariants = false } = {}) => {
    return fetch(`${elakay_API}/dropshipping/cj/products/${productId}/sync`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ includeAllVariants }),
    })
        .then(response => response.json())
        .catch(err => ({ success: false, error: err.message || "Une erreur inconnue est survenue" }));
};

export const updateCJSyncLocks = (token, productId, locks) => {
    return fetch(`${elakay_API}/dropshipping/cj/products/${productId}/sync-locks`, {
        method: "PATCH",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ locks })
    })
        .then(response => response.json())
        .catch(err => ({ success: false, error: err.message || "Une erreur inconnue est survenue" }));
};

// Bascule l'onglet "Automatic Synchronization" (editProduct) -- n'affecte
// jamais le bouton "Sync Now" (toujours manuel/explicite).
export const updateCJAutoSync = (token, productId, autoSync) => {
    return fetch(`${elakay_API}/dropshipping/cj/products/${productId}/auto-sync`, {
        method: "PATCH",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ autoSync })
    })
        .then(response => response.json())
        .catch(err => ({ success: false, error: err.message || "Une erreur inconnue est survenue" }));
};

// --- Mapping avancé CJ -> Elakay (bloc repliable "Advanced field mapping") ---

export const getCJSyncRegistry = (token) => {
    return fetch(`${elakay_API}/dropshipping/cj/sync-registry`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        },
    })
        .then(response => response.json())
        .catch(err => ({ success: false, error: err.message || "Une erreur inconnue est survenue" }));
};

export const syncCJProductWithMapping = (token, productId, mapping, locks = {}, options = {}) => {
    return fetch(`${elakay_API}/dropshipping/cj/products/${productId}/sync-with-mapping`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ mapping, locks, options })
    })
        .then(response => response.json())
        .catch(err => ({ success: false, error: err.message || "Une erreur inconnue est survenue" }));
};

export const getCJProductConsole = (token, productId) => {
    return fetch(`${elakay_API}/dropshipping/cj/products/${productId}/console`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        },
    })
        .then(response => response.json())
        .catch(err => ({ success: false, error: err.message || "Une erreur inconnue est survenue" }));
};

// Convertit dropshippingData.variants en Product.filterProduct[] (vrai
// système de variantes Elakay). catID optionnel : si omis, le backend
// utilise la catégorie déjà liée au produit (categoriesID[0]). `mode`
// (auto_once/always/locked) optionnel : persiste le mode de sync automatique
// choisi par le seller en même temps que cette application immédiate.
// externalVariantId optionnel : restreint la conversion à ce seul variant
// CJ (bouton "ajouter" individuel de CJVariantsSyncPanel) plutôt qu'à tout
// le produit (bouton "Sync All").
// `password`, when provided, is sent directly (X-Elakay-Password-Attached
// bypasses the global window.fetch confirmation interceptor, same as
// deleteFilterProduct above) instead of relying on that interceptor.
export const convertCJVariantsToFilterProduct = (token, productId, catID, mode, externalVariantId, confirmation = {}) => {
    return fetch(`${elakay_API}/dropshipping/cj/products/${productId}/convert-variants`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            ...(confirmation.confirmationToken ? { "X-Elakay-CJ-Confirmation": confirmation.confirmationToken, "X-Dropshipping-Action": confirmation.confirmationAction || "CJ_FILTER_UPDATE" } : {})
        },
        body: JSON.stringify({
            ...(catID ? { catID } : {}),
            ...(mode ? { mode } : {}),
            ...(externalVariantId ? { externalVariantId } : {})
        })
    })
        .then(response => response.json())
        .catch(err => ({ success: false, error: err.message || "Une erreur inconnue est survenue" }));
};

// Forme des vignettes CJVariantSwatches (productPreview.js) : "square"
// (défaut) / "circle" / "none" (masque le sélecteur de variants).
export const updateCJVariantSwatchStyle = (token, productId, variantSwatchStyle) => {
    return fetch(`${elakay_API}/dropshipping/cj/products/${productId}/variant-swatch-style`, {
        method: "PATCH",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ variantSwatchStyle })
    })
        .then(response => response.json())
        .catch(err => ({ success: false, error: err.message || "Une erreur inconnue est survenue" }));
};

// Fusionne les mots donnés (suggestions CJ cochées, ou "select all" déjà
// résolu côté client) dans product.keysProduct -- toujours un merge, jamais
// un remplacement (voir mergeUniqueKeywords côté serveur).
export const syncCJKeywords = (token, productId, words) => {
    return fetch(`${elakay_API}/dropshipping/cj/products/${productId}/sync-keywords`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ words })
    })
        .then(response => response.json())
        .catch(err => ({ success: false, error: err.message || "Une erreur inconnue est survenue" }));
};

export const DeleteComments = (token, productID, commentID) => {
    if (!isMongoObjectId(productID)) return Promise.resolve(invalidProductIdResult);
    return fetch(`${elakay_API}/products/DeleteComments/${productID}/${commentID}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

export const addToUserView = (newItem) => {
  const key = 'userView';

  // Récupère les données existantes
  let existing = [];
  try {
    existing = JSON.parse(localStorage.getItem(key)) || [];
  } catch {
    existing = [];
  }

  // Retire l'éventuel doublon de newItem
  const filtered = existing.filter(item => item._id !== newItem._id);

  // Ajoute newItem en premier
//   const updated = [newItem].concat(filtered);
filtered.unshift(newItem); // équivalent à [newItem, ...filtered]

  // Si plus de 15, on retire le dernier
  const limited = filtered.slice(0, 30);

  // Enregistrer dans le localStorage
  localStorage.setItem(key, JSON.stringify(limited));
}

export const getUserView = () => {
  const key = 'userView';
  const data = localStorage.getItem(key);

  try {
    return data ? JSON.parse(data) : [];
  } catch (error) {
    console.error('Erreur de parsing userView :', error);
    return [];
  }
}

export const creatUserViewed = (token, view) => {
    return fetch(`${elakay_API}/user/viewed`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(view)
    })
        .then(response => {
            return response.json();
        })
        .catch(err =>  {return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    }
}
);
};

export const creatHistorySearch = (token, historyData) => {
  return fetch(`${elakay_API}/user/historySearch`, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(historyData),
  })
    .then((res) => res.json())
    .catch((err) => ({
      success: false,
      error: err?.message || "Une erreur inconnue est survenue",
    }));
};


export async function handleUserViewed(token, viewId, viewed = []) {
  try {
    const item = { _id: viewId };

    // Si pas connecté, rien à synchroniser vers le serveur
    if (!token) { 
    // Toujours stocker localement (met à jour userView dans localStorage)
    addToUserView(item);

      return { success: true, localOnly: true };
    }

    // Récupère les éléments locaux (peut retourner [] si rien)
    const localData = Array.isArray(getUserView()) ? getUserView() : [];

    // Construire la liste combinée : locaux d'abord, puis l'item courant, puis la liste serveur existante
    // (si viewed est déjà la liste serveur)

    const combinedRaw = [  
      item,
      ...localData
    ];
    
    // Nettoyage : garder éléments valides (_id défini) et supprimer doublons en conservant le premier rencontré
    const cleaned = combinedRaw
      .filter(v => v && v._id != null && v._id !== undefined)
      .reduce((map, cur) => {
        if (!map.has(cur._id)) map.set(cur._id, cur);
        return map;
      }, new Map());

    // Crée le tableau final en conservant l'ordre d'apparition (localData en premier)
    const finalArray = Array.from(cleaned.values()).slice(0, 30); // limiter à 30

    // Appel unique au serveur: creatUserViewed attend maintenant un array dans le body
    const response = await creatUserViewed(token, finalArray);

    // Si tout est ok, vider le stockage local
    if (response && (response.success === true || response.viewed)) {
      try {
        localStorage.removeItem('userView');
      } catch (e) {
        // ne bloque pas si localStorage n'est pas accessible
        console.warn('Impossible de vider localStorage userView:', e);
      }
    }

    return {
      success: true,
      synced: true,
      serverResponse: response,
      finalViewed: finalArray
    };
  } catch (err) {
    console.error('Erreur dans handleUserViewed :', err);
    return {
      success: false,
      error: err?.message || 'Une erreur inconnue est survenue'
    };
  }
}

export const userDislikeCommentsProduct = async (token, productID, commentID) => {
      if (!isMongoObjectId(productID)) return invalidProductIdResult;
      try{
   const response = await fetch(`${elakay_API}/products/comments/dislike/${encodeURIComponent(productID)}/${encodeURIComponent(commentID)}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        }
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors de la mise à jour du dislike du commentaire :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
}; 

// dislike and like commentaire
export const userLikeCommentsProduct = async (token, productID, commentID) => {
      if (!isMongoObjectId(productID)) return invalidProductIdResult;
      try{
   const response = await fetch(`${elakay_API}/products/comments/like/${encodeURIComponent(productID)}/${encodeURIComponent(commentID)}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        }
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors de la mise à jour du like du commentaire :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  } 
};

export const getTeamPaymentIntent = async () => {
const token = getAuthToken();
if (!token) return;

  try {
    const response = await fetch(
      `${elakay_API}/team-payment-intent`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        errorData.message ||
        errorData.error ||
        "Erreur team payment"
      );
    }

    const encryptedData = await response.json();
   
    const donneesClaires = await decryptData(encryptedData);
    return donneesClaires;

  } catch (err) {
    console.error(
      "Erreur getTeamPaymentIntent :",
      err
    );

    return {
      success: false,
      error:
        err.message ||
        "Une erreur inconnue est survenue"
    };
  }
};

// export const createOrder = async (tokenS, createOrderData, graphic) => {
//     let query = graphic? `?design=${JSON.stringify(graphic)}&ust=c`: '';
//     try{
//    const response = await  fetch(`${elakay_API}/order/createOrders${query}`, {
//         method: "POST",
//         headers: {
//             Accept: "application/json",
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${tokenS.token}`,
//             UserPUBToken : `Bearer ${tokenS.pubToken}`
//         },
//         body: JSON.stringify(createOrderData)
//     })

//       // Vérifie si le statut est une erreur HTTP
//     if (!response.ok) {
//       const errorData = await response.json();
//       throw new Error(errorData.error || "Erreur d'identification");
//     }
//      const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
//     const donneesClaires = await decryptData(encryptedData);

//     return donneesClaires;

// } catch (err) {
//     console.error("Erreur lors du chargement des catégories :", err);
//    return {
//       success: false,
//       error: err.message || "Une erreur inconnue est survenue"
//     };
//   }
// }; 

// product comments elakay  et vote comments elakay

export const createOrder = async (tokenS, createOrderData, hasGraphic = false) => {
  const attempt = checkoutAttempt(isAuthenticated()?.user?._id || tokenS.token, createOrderData);

  const query = hasGraphic ? `?design=true&ust=c` : '?ust=c';
  /* Détecter les File objects dans les layers (custom/template) et les images ask */
  const layerFiles = [];
  const askRefFiles = [];

  if (hasGraphic) {
    const products = Array.isArray(createOrderData.products)
      ? createOrderData.products
      : [createOrderData.products];

    /* Layers (mode custom / template) */
    (products[0]?.graphic?.slots || []).forEach((slot, si) => {
      (slot.slotState?.layers || []).forEach((layer, li) => {
        if (typeof File !== "undefined" && layer.file instanceof File) {
          layerFiles.push({ file: layer.file, fieldName: `layer_${si}_${li}`, si, li });
        }
      });
    });

    /* Ask ref images (mode ask) — toujours ask index 0 au checkout */
    const askImages = products[0]?.graphic?.askSellerData?.images;
    if (Array.isArray(askImages)) {
      askImages.forEach((img, ri) => {
        if (typeof File !== "undefined" && img instanceof File) {
          askRefFiles.push({ file: img, fieldName: `askref_0_${ri}`, ri });
        }
      });
    }
  }

  try {
    let body;
    let headers = {
      Accept: "application/json",
      "Idempotency-Key": attempt.key,
      Authorization: `Bearer ${tokenS.token}`,
      UserPUBToken: `Bearer ${tokenS.pubToken}`
    };

    const hasFiles = layerFiles.length > 0 || askRefFiles.length > 0;

    if (hasFiles) {
      /* Nettoyer le body (retirer les File objects non sérialisables) */
      const cleanBody = JSON.parse(JSON.stringify(createOrderData, (key, val) => {
        if (typeof File !== "undefined" && val instanceof File) return undefined;
        return val;
      }));

      /* Marquer les layers avec leurs fichiers */
      layerFiles.forEach(({ fieldName, si, li }) => {
        const layer = cleanBody.products?.[0]?.graphic?.slots?.[si]?.slotState?.layers?.[li];
        if (layer) {
          layer.hasNewFile = true;
          layer.fileFieldName = fieldName;
          layer.urlImg = "";
          delete layer.file;
        }
      });

      /* Marquer les images ask avec leurs fichiers */
      if (askRefFiles.length > 0) {
        const askData = cleanBody.products?.[0]?.graphic?.askSellerData;
        if (askData && Array.isArray(askData.images)) {
          askRefFiles.forEach(({ fieldName, ri }) => {
            askData.images[ri] = { hasNewFile: true, fileFieldName: fieldName };
          });
        }
      }

      const formData = new FormData();
      formData.append("data", JSON.stringify(cleanBody));
      layerFiles.forEach(({ file, fieldName }) => formData.append(fieldName, file));
      askRefFiles.forEach(({ file, fieldName }) => formData.append(fieldName, file));

      body = formData;
      /* Ne pas définir Content-Type : le navigateur le fait automatiquement avec le boundary */
    } else {
      /* Pas de fichiers → JSON classique */
      headers["Content-Type"] = "application/json";
      body = JSON.stringify(createOrderData);
    }

    const response = await fetch(`${elakay_API}/order/createOrders${query}`, {
      method: "POST",
      headers,
      body
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw Object.assign(new Error(errorData.error || `HTTP ${response.status}`), { code: errorData.code });
    }

    const encryptedData = await response.json();
    const result = await decryptData(encryptedData);
    // Keep the persisted receipt key across reload/retry.
    if (result?._id) { result.checkoutReplayed = attempt.confirmed; attempt.markCreated(); }
    return result;

  } catch (err) {
    console.error("Erreur lors de la création de la commande :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue",
      // e.g. SHIPPING_CHANGED: the server's recomputed shipping differs from the one displayed.
      code: err.code || null
    };
  }
};

export const AddComments = async (token, productID, comments) => {
    if (!isMongoObjectId(productID)) return invalidProductIdResult;
    try{
   const response = await fetch(`${elakay_API}/products/comments/${productID}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(comments)
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

        } catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
    
}; 

export const list = async (skip, limit, params) => {
      try {
 const query = buildQuery({
    search: params,
    skip: cleanSkip(skip),
    order: "desc",
    limit: clampLimit(limit),
    ...locationQueryParams(undefined)
 });
 const response = await  fetch(`${elakay_API}/products/search?${query}`, {
        method: "GET",
        headers: bearerHeaders({ Authorization: getAuthToken() })
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
        const donneesClaires = await decryptData(encryptedData);
    
        return donneesClaires;
} catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const getFilteredProducts = (skip, limit, filters = {}) => { 
    const data = {
        limit,
        skip,
        filters
    };
    return fetch(`${elakay_API}/products/by/search`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

export const getComments = async (productId, skip, limit, sortBy) => {
       try {
 const response = await fetch(`${elakay_API}/products/getCommentaire/${productId}?sortBy=${sortBy}&skip=${skip}&order=desc&limit=${limit}`, {
        method: "GET"
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

     const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
        const donneesClaires = await decryptData(encryptedData);
    
        return donneesClaires;
} catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
       
};


export const linkFTP = (productID, filID, token) => {
    return fetch(`${elakay_API}/products/linkFTP/${productID}/${filID}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

export const UnlinkFTP = (productID, filID, token) => {
    return fetch(`${elakay_API}/products/UnlinkFTP/${productID}/${filID}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

export const linkVFTP = (productID, filID, name, token) => {
    return fetch(`${elakay_API}/products/linkVFTP/${productID}/${filID}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({name})
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

export const UnlinkVFTP = (productID, filID, name, token) => {
    return fetch(`${elakay_API}/products/UnlinkVFTP/${productID}/${filID}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({name})
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

export const AddFormFilProView = (productID, filID, formValueFil, token) => {
    return fetch(`${elakay_API}/products/AddFormFilProView/${productID}/${filID}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({formValueFil})
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

export const TextFilProView = (productID, filID, textRead, token) => {
    if (!productID || !filID || productID === "undefined" || filID === "undefined") {
        return Promise.resolve({ success: false, error: elakayAutoText("h_c0b8dca1bd543d", "Missing product or filter identifier") });
    }
    return fetch(`${elakay_API}/products/textFilProView/${productID}/${filID}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({textRead})
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

export const AddFilImg = (productID, filID, Images, token) => {
    return fetch(`${elakay_API}/products/AddFilImg/${productID}/${filID}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({Images})
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

export const DeletFilImg = (productID, filID, Images, token) => {
    return fetch(`${elakay_API}/products/DeletFilImg/${productID}/${filID}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({Images})
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

export const FormInputFilProView = (productID, filID, formInput, token) => {
    return fetch(`${elakay_API}/products/FormInputFilProView/${productID}/${filID}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({formInput})
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

export const getImages = (productId) => {
    return fetch(`${elakay_API}/img/${productId}`, {
        method: "GET"
    })
        .then(response => {
            return response.json();
        })
        // Réponse `null` (aucune galerie) -> galerie vide : les appelants lisent
        // `data.error` / `data.galeries` et plantaient sur "reading 'error'".
        .then(data => data ?? { _id: productId, galeries: [] })
        .catch(err => { return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    }
}
);
};

export const linkImagesToProduct = (token, productId, filImages, queryDel={}) => {

  const { 
    SPO = false, 
    SPA = false, 
    I = undefined
    } = queryDel;
  return fetch(`${elakay_API}/linkImagesToProduct/${productId}?SPO=${SPO}&SPA=${SPA}&I=${I}`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(filImages)
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
    }

    export const getPubCategories = async (categoryID, userID, limit, desc, sortBy)=> {
    try{
   const location = buildQuery(locationQueryParams(undefined));
   const response = await fetch(`${elakay_API}/user/getPubCategories/${categoryID}/${userID}?limit=${limit}&order=${desc}&sortBy=${sortBy}${location ? `&${location}` : ""}`, {
            method: "GET",
            headers: bearerHeaders({ Authorization: getAuthToken() })
        })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
       const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

                } catch (err) {
     console.error("Erreur lors du chargement des catégories :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
     }
    };


    export const loadFollowUserShop = async (userID, limit, desc, sortBy)=> {
        try{
   const location = buildQuery(locationQueryParams(undefined));
   const response = await  fetch(`${elakay_API}/user/getFollowUserShop/${userID}?limit=${limit}&order=${desc}&sortBy=${sortBy}${location ? `&${location}` : ""}`, {
            method: "GET",
            headers: bearerHeaders({ Authorization: getAuthToken() })
        })
    
      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

 const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }

    };

    export const taxProductArea =(code, zipCode)=> {
        return fetch(`${elakay_API}/user/taxProdArea/${code}/${zipCode}`, {
            method: "GET"
        })
            .then(response => {
                return response.json();
            })
            .catch(err => { return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    }
    }
    );
    };

const normalizeTaxCountryCode = (value) => {
  const key = String(value || "").trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z]/gi, "").toUpperCase();
  const aliases = {
    US: "US", USA: "US", UNITEDSTATES: "US", UNITEDSTATESOFAMERICA: "US",
    CA: "CA", CAN: "CA", CANADA: "CA",
    MX: "MX", MEX: "MX", MEXICO: "MX",
    DO: "DO", DOM: "DO", DOMINICANREPUBLIC: "DO", REPUBLICADOMINICANA: "DO",
    JM: "JM", JAM: "JM", JAMAICA: "JM", HT: "HT", HTI: "HT", HAITI: "HT",
    BS: "BS", BHS: "BS", BAHAMAS: "BS", TT: "TT", TTO: "TT", TRINIDADANDTOBAGO: "TT",
  };
  return aliases[key] || key.slice(0, 2);
};

export const taxProductAreaByState = async (code, zipcode, suppliedRegionCode) => {

  try {
    const countryCode = normalizeTaxCountryCode(code);
    const postalCode = String(zipcode || "").replace(/[\s-]+/g, "").toUpperCase();
    let regionCode = suppliedRegionCode ? String(suppliedRegionCode).trim() : "";

    if (!regionCode && (countryCode === "US" || countryCode === "CA")) {
      const lookupPostalCode = countryCode === "CA" ? postalCode.slice(0, 3) : postalCode;
      const areaResponse = await fetch(`${elakay_API}/user/countries?code=${encodeURIComponent(countryCode)}&zipcode=${encodeURIComponent(lookupPostalCode)}`, {
        method: "GET",
        headers: { Accept: "application/json", "Content-Type": "application/json" },
      });
      if (areaResponse.ok) {
        const areaCountry = await areaResponse.json();
        regionCode = areaCountry.state_code || areaCountry.province_code || "";
      }
    }

    const taxResponse = await fetch(`${elakay_API}/user/taxProdArea/${encodeURIComponent(countryCode)}/${encodeURIComponent(regionCode || "NA")}/${encodeURIComponent(postalCode || "NA")}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
    });

    if (!taxResponse.ok) {
      throw new Error(`Erreur lors de la récupération des données de taxe : ${taxResponse.statusText}`);
    }

    const taxProdArea = await taxResponse.json();
    return taxProdArea;
  } catch (err) {
    console.error("Erreur lors de la récupération des données de taxe :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    }; // retourne un tableau vide en cas d'erreur
  }
};

/* auth/graphicOrder.js (ou wherever tu mets tes API helpers) */

// import { elakay_API } from "./config";

/**
 * Sauvegarde un brouillon de design seller
 */
// saveSellerDesign / submitSellerDesign were removed (UP-15): they called
// /order/:id/seller-design/(save|submit), routes that never existed on the
// server, and nothing called them any more. The seller design flow uses
// PATCH /order/:oid/graphic (updateOrderGraphic) and
// POST /order/:oid/graphic/submit.


/* Approuver le design du seller */
export const approveSellerDesign = async (tokenS, orderId) => {
  try {
    const response = await fetch(`${elakay_API}/order/${orderId}/graphic/approve`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${tokenS.token}`,
        UserPUBToken: `Bearer ${tokenS.pubToken || ""}`
      }
    });
    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.error || `HTTP ${response.status}`);
    }
    return await response.json();
  } catch (err) {
    return { success: false, error: err.message };
  }
};

/* Rejeter le design du seller */
export const rejectSellerDesign = async (tokenS, orderId) => {
  try {
    const response = await fetch(`${elakay_API}/order/${orderId}/graphic/reject`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${tokenS.token}`,
        UserPUBToken: `Bearer ${tokenS.pubToken || ""}`
      }
    });
    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.error || `HTTP ${response.status}`);
    }
    return await response.json();
  } catch (err) {
    return { success: false, error: err.message };
  }
};

/* Demander une révision (ajoute une demande dans askSellerData[]) */
export const requestRevision = async (tokenS, orderId, { revisionMessage, requestNumber }) => {
  try {
    const response = await fetch(`${elakay_API}/order/${orderId}/graphic/revision`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${tokenS.token}`,
        UserPUBToken: `Bearer ${tokenS.pubToken || ""}`
      },
      body: JSON.stringify({
        revisionMessage,
        requestNumber
      })
    });
    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.error || `HTTP ${response.status}`);
    }
    return await response.json();
  } catch (err) {
    return { success: false, error: err.message };
  }
};

/* auth/apiProduct.js */

/**
 * updateOrderGraphic - VERSION AVEC UPLOAD FILES
 * 
 * Envoie en FormData pour supporter les fichiers Files
 */
export const updateOrderGraphic = async (tokenS, orderId, graphicData, options = {}) => {
  const mode = options.mode || "seller";
  const status = options.status || "in_review";
  const query = `?mode=${mode}&status=${status}`;

  try {
    /* 🆕 Construire FormData avec les fichiers extraits */
    const formData = new FormData();

    /* Clone graphic data pour ne pas modifier l'original */
    const cleanProducts = JSON.parse(JSON.stringify(graphicData.products || [graphicData]));

    /* Extract Files des slots et remplacer par des markers */
    if (graphicData.files && Array.isArray(graphicData.files)) {
      graphicData.files.forEach(({ slotIndex, layerIndex, file }) => {
        if (file instanceof File) {
          const fieldName = `layer_${slotIndex}_${layerIndex}`;
          formData.append(fieldName, file);

          /* Marquer dans le JSON que ce layer a un fichier à uploader */
          if (cleanProducts[0]?.graphic?.slots?.[slotIndex]?.slotState?.layers?.[layerIndex]) {
            cleanProducts[0].graphic.slots[slotIndex].slotState.layers[layerIndex].hasNewFile = true;
            cleanProducts[0].graphic.slots[slotIndex].slotState.layers[layerIndex].fileFieldName = fieldName;
            /* Nettoyer les URLs blob/data qui ne servent à rien côté backend */
            cleanProducts[0].graphic.slots[slotIndex].slotState.layers[layerIndex].urlImg = "";
          }
        }
      });
    }

    /* Ajouter aussi les fichiers refs de l'askSellerData si présents */
    /* ... (selon ta structure) ... */

    /* Ajouter le JSON dans un champ "data" */
    formData.append("data", JSON.stringify({
      products: cleanProducts,
      sellerNotes: graphicData.sellerNotes || ""
    }));
    const response = await fetch(
      `${elakay_API}/order/${orderId}/graphic${query}`,
      {
        method: "PATCH",
        headers: {
          /* ⚠️ NE PAS mettre Content-Type — FormData le fait automatiquement avec boundary */
          Accept: "application/json",
          Authorization: `Bearer ${tokenS.token}`,
        },
        body: formData
      }
    );

    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.error || `HTTP ${response.status}`);
    }

    return await response.json();
  } catch (err) {
    console.error("[updateOrderGraphic] Error:", err);
    return { success: false, error: err.message };
  }
};

/**
 * submitOrderGraphic
 * Soumet le design (change status à draft_ready, notifie client)
 */
export const submitOrderGraphic = async (tokenS, orderId) => {
  try {
    const response = await fetch(
      `${elakay_API}/order/${orderId}/graphic/submit`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenS.token}`,
        }
      }
    );

    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.error || `HTTP ${response.status}`);
    }

    return await response.json();
  } catch (err) {
    console.error("[submitOrderGraphic] Error:", err);
    return { success: false, error: err.message };
  }
};

/* auth/apiProduct.js */

/**
 * updateOrderGraphicMultipart
 * Reçoit un FormData déjà construit (par le hook) et l'envoie en PATCH.
 */
export const updateOrderGraphicMultipart = async (
  tokenS,
  orderId,
  formData,
  options = {}
) => {
  const mode = options.mode || "seller";
  const status = options.status || "in_review";

  const query = `?mode=${encodeURIComponent(mode)}&status=${encodeURIComponent(status)}`;

  try {
    if (!orderId) {
      return { success: false, error: __elakayText("t001", "orderId missing") };
    }

    if (!(formData instanceof FormData)) {
      return { success: false, error: __elakayText("t002", "formData is not FormData") };
    }

    const hasData = Array.from(formData.keys()).length > 0;

    if (!hasData) {
      return { success: false, error: __elakayText("t003", "FormData is empty") };
    }

    const response = await fetch(
      `${elakay_API}/order/${orderId}/graphic${query}`,
      {
        method: "PATCH",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${tokenS?.token || ""}`
        },
        body: formData
      }
    );

    const text = await response.text();

    let result = {};
    try {
      result = text ? JSON.parse(text) : {};
    } catch {
      result = { error: text };
    }

    if (!response.ok) {
      console.error("BACKEND ERROR:", result);

      return {
        success: false,
        status: response.status,
        error: result.error || result.message || `HTTP ${response.status}`,
        details: result
      };
    }

    return result;
  } catch (err) {
    console.error("[updateOrderGraphicMultipart] Error:", err);

    return {
      success: false,
      error: err.message
    };
  }
};

/**
 * createOrderMultipart
 * Pour le flow customer (Checkout) : crée l'order avec les fichiers layers.
 */
export const createOrderMultipart = async (tokenS, orderBody, files = [], hasGraphic = false) => {
  const query = hasGraphic ? "?design=true&ust=c" : "?ust=c";
  const attempt = checkoutAttempt(isAuthenticated()?.user?._id || tokenS.token, { orderBody, files });

  try {
    const formData = new FormData();
    formData.append("data", JSON.stringify(orderBody));

    files.forEach(({ file, fieldName }) => {
      formData.append(fieldName, file);
    });

    const response = await fetch(
      `${elakay_API}/order/createOrders${query}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Idempotency-Key": attempt.key,
          Authorization: `Bearer ${tokenS.token}`,
          UserPUBToken: `Bearer ${tokenS.pubToken || ""}`
        },
        body: formData
      }
    );

    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.error || `HTTP ${response.status}`);
    }
    const result = await response.json();
    // Retain the receipt key across refresh/retry; creation has no payment side effect.
    return result;
  } catch (err) {
    console.error("[createOrderMultipart] Error:", err);
    return { success: false, error: err.message };
  }
};


// Product Information switch (sellActive.sell) and its profitability preview. Plain JSON (no encryption): the server
// always recomputes profit/availability itself -- these calls only carry the Seller's wish.
const sellActiveApi = async (token, method, path, body) => {
    try {
        const response = await fetch(`${elakay_API}/products/${path}`, {
            method,
            headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${token}` },
            body: JSON.stringify(body || {}),
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) return { success: false, status: response.status, ...data, error: data.error || "Request failed" };
        return data;
    } catch (err) {
        return { success: false, error: err.message || "Une erreur inconnue est survenue" };
    }
};
export const setProductSellActive = (token, productID, body) => sellActiveApi(token, "PUT", `${encodeURIComponent(productID)}/sellActive`, body);
export const previewProductProfitability = (token, productID, body) => sellActiveApi(token, "POST", `${encodeURIComponent(productID)}/profitability`, body);
export const saveProductPricing = (token, productID, body) => sellActiveApi(token, "PUT", `${encodeURIComponent(productID)}/pricing`, body);
